module.exports = __webpack_public_path__ + "static/media/planet-ringed.6c308d70.svg";